// extracted by mini-css-extract-plugin
export default {"description":"Z2Mr3 ZdH1P"};